import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/mastercard_shop_banner.webp";

const MastercardShopModal = ({ serialNumber, onClose, onPlay, onVideoEnded }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Mastercard Shop"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p>
              {
                "Your dedicated Mastercard shop in the lounge features an exclusive merchandise range, and an ultra-fast self-checkout system."
              }
            </p>
            <p>
              {
                "An amount of 8,000 HUF (equivalent to €20) has been added to your wristband to spend at the shop.​"
              }
            </p>
            <p>
              {
                "Scan your wristband to register your shopping bag and drop it at the shop exit."
              }
            </p>
          </div>
          <div className="section bg-black">
            <p>{"Watch how to experience the Mastercard shop here:​"}</p>

            <video
              src={
                "https://s3.eu-west-2.amazonaws.com/www.digiseq.co.uk/mastercard/MC_MastercardStore_SBs_VideoThree_v11.mp4"
              }
              playsInline
              preload="auto"
              controls
              onPlay={() => onPlay()}
              onEnded={() => onVideoEnded()}
            />
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default MastercardShopModal;
